import { ApplicationQuestion } from '@features/applicationQuestions';

export const applicationQuestionsKey = 'jopPostingQuestions';
export const errorMessage = 'Sorry, something went wrong';

export const predefinedQuestions: Partial<ApplicationQuestion>[] = [
  {
    label: 'Industry experience',
    question: 'Do you have previous experience working in this industry?',
    question_type: 1,
  },
  {
    label: 'Highly organized',
    question: 'Do you consider yourself highly organized?',
    question_type: 1,
  },
  {
    label: 'Multitasking',
    question: 'Are you comfortable multi-tasking?',
    question_type: 1,
  },
  {
    label: 'Engaging with customers',
    question:
      'Are you comfortable engaging with customers in a conversational manner?',
    question_type: 1,
  },
  {
    label: 'Flexible Schedule',
    question:
      'Are you willing to work a flexible schedule including nights, weekends, and holidays?',
    question_type: 1,
  },
  {
    label: 'English proficiency',
    question: 'Do you speak and write in English fluently?',
    question_type: 1,
  },
  {
    label: 'Diploma / GED',
    question: 'Do you have a high school diploma or GED?',
    question_type: 1,
  },
  {
    label: 'Money handling experience',
    question: 'Do you have experience handling money?',
    question_type: 1,
  },
  {
    label: 'Working on your feet',
    question:
      'Are you willing to work on your feet for extended periods of time?',
    question_type: 1,
  },
  {
    label: 'Reliable transportation',
    question: 'Do you have reliable transportation?',
    question_type: 1,
  },
  {
    label: 'Have a cell phone',
    question: 'Do you have a cell phone?',
    question_type: 1,
  },
  {
    label: 'Experience in the position',
    question:
      "Do you have previous experience in the position you're applying for?",
    question_type: 1,
  },
  {
    label: 'Valid Licenses and Certifications',
    question:
      "Do you have any currently valid licenses or certifications that pertain to the position you're applying for? If they're not listed on your resume, please list them here.",
    question_type: 1,
  },
  {
    label: 'Primary job',
    question: 'Will this be your primary job?',
    question_type: 1,
  },
  {
    label: 'Previously employed here',
    question:
      'Are you currently or have you ever been employed by one of our establishments?',
    question_type: 1,
  },
  {
    label: 'Management experience',
    question: 'Do you have management experience?',
    question_type: 1,
  },
  {
    label: 'Student status',
    question: 'Are you currently a student?',
    question_type: 1,
  },
  {
    label: 'Previous terminations',
    question: 'Have you ever been fired from a job?',
    question_type: 1,
  },
  {
    label: 'Referral',
    question: 'Were you referred by anyone? If so, who?',
    question_type: 1,
  },
];
